// priorityCalculator.js

export const calculatePriority = (lead) => {
    // Define priority logic based on attributes
    if (lead.source === "Referral" || lead.service_category === "High Value Product") {
      return "High";
    } else if (lead.source === "Website") {
      return "Medium";
    } else {
      return "Low";
    }
  };